var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-2"
    }
  }, [_vm._v("arrow_back")])], 1), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.inbox')) + "\n      ")]), _c('v-spacer')], 1), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "text-xs-center": ""
    }
  }, [_vm.result.length > 0 ? _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l(_vm.result, function (item, index) {
    return [item.header ? _c('v-subheader', {
      key: index
    }, [_vm._v("\n                " + _vm._s(item.header) + "\n              ")]) : item.divider ? _c('v-divider', {
      key: index,
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-tile', {
      key: index,
      class: {
        'red lighten-3': !item.isRead
      },
      attrs: {
        "avatar": "",
        "to": {
          name: 'message',
          params: {
            id: item.id
          }
        }
      },
      on: {
        "click": function click($event) {
          return _vm.messageClicked(item);
        }
      }
    }, [_c('v-list-tile-avatar', {
      attrs: {
        "color": "indigo"
      }
    }, [_c('span', {
      staticClass: "white--text headline"
    }, [_vm._v(_vm._s(item.title.charAt(0)))])]), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(item.subtitle)
      }
    }), item.read_at ? _c('v-list-tile-sub-title', [_vm._v("Read at: " + _vm._s(item.read_at))]) : _vm._e()], 1)], 1)];
  })], 2)], 1) : _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.inboxIsEmpty')))])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }